import { useTitleSymbolFieldController } from "./TitleSymbolField.controller";
import { TitleSymbolFieldPresentation } from "./TitleSymbolField.pres";

export interface TitleSymbolFieldProps {
  value?: string;
  onCommit: (symbol: string) => void;
  error?: string;
}

export const TitleSymbolField = ({
  value,
  onCommit,
  error,
}: TitleSymbolFieldProps) => {
  const controller = useTitleSymbolFieldController({ value, onCommit, error });
  return <TitleSymbolFieldPresentation {...controller} />;
};
